import React, { Fragment, useEffect } from 'react'
import { SharedStateType } from './types'
import { StepperShell } from '../../components/_WMS/Stepper'
import {
  AllCyclicalsScreen,
  ErrorStep,
  InventoryCheckDetailScreen,
  ScanSku,
  ShowInventoryCheckPositions,
  ValidateInventoryWorkOrder
} from './stepper/screens'
import { WaitingScreen } from './stepper/screens/WaitingScreen'
import { SuccessInventoryCheck } from './stepper/screens/SuccessInventoryCheck'
import { useProductOrigins } from '../../hooks'

const InventoryCheckHandheldPage: React.FC = () => {
  const initialSharedState: SharedStateType = {
    workOrderId: undefined,
    positionCode: undefined,
    error: ''
  }

  const {
    getProductOrigins,
    productOriginsState: { productOrigins }
  } = useProductOrigins()

  useEffect(() => {
    if (productOrigins?.length === 0) {
      getProductOrigins()
    }
  }, [])

  return (
    <Fragment>
      <StepperShell<SharedStateType>
        steps={[
          (props) => <ValidateInventoryWorkOrder {...props} />, // 1. Paso de espera para ingreso o selección de ciclico
          (props) => <ShowInventoryCheckPositions {...props} />, // 2. Paso de selección de posición
          (props) => <WaitingScreen {...props} />, // 3. Paso escaneo de la posición seleccionada
          (props) => <ScanSku {...props} />, // 4. Paso escaneo de los productos
          (props) => <ErrorStep {...props} />, // 5. Paso de errores de validación
          (props) => <SuccessInventoryCheck {...props} />, // 6. Paso de finalización satisfactoria del ciclo en la posición
          (props) => <AllCyclicalsScreen {...props} />, // 7. (No lineal) Paso pantalla desconzco nro ciclo muestra todos los inventarios ciclicos activos
          (props) => <InventoryCheckDetailScreen {...props} /> // 8. (No lineal) Paso pantalla de ver detalle (avance del inventario ciclico)
        ]}        
        initialSharedState={initialSharedState}
      />
    </Fragment>
  )
}

export default InventoryCheckHandheldPage
